import React from "react";
import './Style.scss'

export default function OnboardingProcess() {
 

  const complaintSteps = [
    "Visit https://algoquant.global/ ",
    "Select / Click – Create a Ticket",
    "Therein fill your client id, mobile, mail & issue",
    "Submit your Issue by clicking on Submit button",
    "You will receive Ticket raised confirmation and ticket id on screen, mobile & mail",
    "Click on Ticket status to enter your ticket id and check its status",
    "To escalate it further, please follow the escalation matrix"
  ];

  const offlineSteps = [
    "Visit the office of Algoquant Global",
    "Fill the pre-printed account opening form",
    "Therein fill your personal details (mobile, mail, PAN, Aadhar, etc.)",
    "Fill in your Bank Details",
    "Submit Documents, Photo, Proof of Address, Proof of Identity, Income Details, etc.",
    "Sign A/c Opening Form",
    "A/c will be active after verification"
  ];

  const renderSteps = (steps) =>
    steps.map((step, idx) => (
      <li key={idx} className="onboardingStepItem">
        <span className="stepNumber"></span> {step}
      </li>
    ));

  return (
    <div className="wrapper onboardingContainer">
      {/* <div className="onboardingHeader container headerforall">
        <div className="leftHeader">
          <h1 className="heading">Onboarding Process</h1>
        </div>
      </div> */}
      <div className="onboardingContent paragraphforall container">
      <div className="onboardingSection">
          <h2 className="subHeading">Offline Account Opening Process</h2>
          <ul className="onboardingStepList">{renderSteps(offlineSteps)}</ul>
        </div>
        <div className="onboardingSection">
          <h2 className="subHeading">Complaint Filing and Checking Status Process</h2>
          <ul className="onboardingStepList">{renderSteps(complaintSteps)}</ul>
        </div>
        
      </div>
    </div>
  );
}
